/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import NoConnectionBold from 'DesignSystem/Svgs/NoConnectionBold/index'
import OnboardingMailMask from 'DesignSystem/Svgs/OnboardingMailMask/index'
import React from 'react'
import TitleLarge from 'DesignSystem/TitleLarge/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'
import { animated, useSpring } from "@react-spring/web"



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/App/Auth/SignUpConfirm/Error"
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtSpaceXl = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xl'
        })
let signupConfirmRequestContactMethodTypeValueData = fromData.useDataValue({ viewPath,
context: 'signup_confirm_request',
path: 'contact_method_type',
})
let constantData = 'email'
let aggregateData = fromAggregate.equals(signupConfirmRequestContactMethodTypeValueData, constantData)
let signupConfirmRequestContactMethodTypeValueData1 = fromData.useDataValue({ viewPath,
context: 'signup_confirm_request',
path: 'contact_method_type',
})
let constantData1 = 'email'
let aggregateData1 = fromAggregate.equals(signupConfirmRequestContactMethodTypeValueData1, constantData1)
let animatedVertical31 = useSpring({
"config": {
friction: 10,
tension: 170,
},
"delay": 350,
"from": {"top": "-45px"},
"to": {"top": isBefore ? "0px" : "-45px"},
})
  return (<React.Fragment
>
<div
  data-testid="Error.Vertical"
  data-view-path={viewPath}
 style={{'--bc-2-4QcjJ': dtColorsNeutral700,'--w-1-4QcjJ': isBefore ? "50%" : "100%"}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Error.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-2-4QcjJ': dtColorsWhite,'--bblr-3-4QcjJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbrr-4-4QcjJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btlr-5-4QcjJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--btrr-6-4QcjJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-7-4QcjJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-8-4QcjJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-9-4QcjJ': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--sb-10-4QcjJ': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL,'--soy-11-4QcjJ': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--o-13-4QcjJ': isBefore ? 0 : 1,'--tx-12-4QcjJ': isBefore ? "100px" : "0px",'--w-1-4QcjJ': isMedia.mobile ? "340px" : "500px"}}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="Error.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical2}`}
>
<OnboardingMailMask
  viewPath={`${viewPath}/OnboardingMailMask`}
 width={200}
 height="auto"
/>
</div>
<animated.div
  data-testid="Error.Vertical:3"
  data-view-path={viewPath}
 style={{"--t-14-4QcjJ": animatedVertical31.top,'--o-13-4QcjJ': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical3}`}
>
<NoConnectionBold
  viewPath={`${viewPath}/NoConnectionBold`}
 width={90}
 height="auto"
/>
</animated.div>
<div
  data-testid="Error.Vertical:4"
  data-view-path={viewPath}
 style={{'--bc-2-4QcjJ': dtColorsNeutral400}}
 className={`views-block ${styles.Vertical4}`}
/>
<div
  data-testid="Error.Vertical:5"
  data-view-path={viewPath}
 style={{'--pr-9-4QcjJ': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl,'--pl-7-4QcjJ': typeof dtSpaceXl === 'number' ? `${dtSpaceXl}px` : dtSpaceXl}}
 className={`views-block ${styles.Vertical5}`}
>
<TitleLarge
  viewPath={`${viewPath}/TitleLarge`}
 fontSize={28}
 text={aggregateData ? "Couldn't send Email" : "Couldn't send SMS"}
 data="signup_confirm_request.contact_method_type"
 data="'email'"
 aggregate="/Simple/Data/aggregate.js equals"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 textAlign="center"
 marginTop={dtSpaceS}
 lineHeight="20px"
 text={aggregateData1 ? "Please contact your clinic to have an email added to your account" : "Please contact your clinic to have a cell phone added to your account"}
 data="signup_confirm_request.contact_method_type"
 data="'email'"
 aggregate="/Simple/Data/aggregate.js equals"
/>
</div>
</div>
</div>
{children}
</React.Fragment>)
}